import { UserAgent } from '@quentin-sommer/react-useragent';
import React from 'react';
import ContentLoader from 'react-content-loader';
import styles from './loading.module.scss';

const ResidenceLoading: React.FC = props => {
  return (
    <div className={styles.loading}>
      <UserAgent computer>
        <ContentLoader
          uniqueKey="booking-loading"
          viewBox="0 0 1128 700"
          height={700}
          width={1128}
          speed={2}
          {...props}
        >
          <rect x="0" y="0" rx="14" ry="14" width="800" height="30" />
          <rect x="0" y="70" rx="14" ry="14" width="360" height="220" />
          <rect x="0" y="310" rx="14" ry="14" width="300" height="20" />

          <rect x="390" y="70" rx="14" ry="14" width="360" height="220" />
          <rect x="390" y="310" rx="14" ry="14" width="300" height="20" />

          <rect x="780" y="70" rx="14" ry="14" width="360" height="220" />
          <rect x="780" y="310" rx="14" ry="14" width="300" height="20" />

          <rect x="0" y="380" rx="14" ry="14" width="360" height="220" />
          <rect x="0" y="620" rx="14" ry="14" width="300" height="20" />

          <rect x="390" y="380" rx="14" ry="14" width="360" height="220" />
          <rect x="390" y="620" rx="14" ry="14" width="300" height="20" />

          <rect x="780" y="380" rx="14" ry="14" width="360" height="220" />
          <rect x="780" y="620" rx="14" ry="14" width="300" height="20" />
        </ContentLoader>
      </UserAgent>
      <UserAgent mobile>
        <ContentLoader
          uniqueKey="booking-loading"
          viewBox="0 0 300 300"
          height={300}
          width={300}
          speed={2}
          {...props}
        >
          <rect x="0" y="0" rx="14" ry="14" width="300" height="30" />
          <rect x="0" y="50" rx="14" ry="14" width="300" height="50" />
          <rect x="0" y="120" rx="14" ry="14" width="300" height="50" />
          <rect x="0" y="200" rx="14" ry="14" width="300" height="50" />
        </ContentLoader>
      </UserAgent>
    </div>
  );
};

export default ResidenceLoading;
